import { useEffect } from "react";
import { useRouter } from "@tanstack/react-router";
import { fetchPartnerCode, readStoredPartnerCode, storePartnerCode } from "../api/partners";

// Silent partner attribution for ads: any page opened with ?with={code}
// (e.g. /collections/munros?with=gads) applies the code without the
// /with/{code} landing card. Fetching the code sets the same HttpOnly
// cookie the landing page does (Strava-first signups), and the code is
// stashed for the signup form, which hides its banner for silent codes.
// The param is stripped from the address; other params (gclid) are kept.

const CODE_RE = /^[a-z0-9][a-z0-9-]{1,39}$/; // mirrors normalisePartnerCode (api)

export function usePartnerParam(): void {
  const router = useRouter();

  useEffect(() => {
    const url = new URL(window.location.href);
    const raw = url.searchParams.get("with");
    if (raw == null) return;

    url.searchParams.delete("with");
    // Through the router's history so its location stays in step.
    router.history.replace(url.pathname + url.search + url.hash);

    const code = raw.trim().toLowerCase();
    if (!CODE_RE.test(code)) return;
    // First code wins, like the server: a creator link opened earlier keeps its credit.
    if (readStoredPartnerCode()) return;

    fetchPartnerCode(code)
      .then(({ partner }) => storePartnerCode(partner.code, { silent: true }))
      .catch(() => {
        // Unknown or disabled code: the visitor just browses as normal.
      });
  }, [router]);
}
